export type GetProjectsRequest = {
  pjtNameOrDesc?: string;
  prdDplymntDateRangFrom?: string;
  prdDplymntDateRangTo?: string;
  stgDplymntDateRangFrom?: string;
  stgDplymntDateRangTo?: string;
  pjtRgstrDateRangFrom?: string;
  pjtRgstrDateRangTo?: string;
  pjtStsList?: string[];
  pjtLnchTypeList?: string[];
  dipList?: string[];
  userId?: string;
  isPmyOnly?: string;
  cpntIdList?: string[];
  pjtId?: string;
  pjtName?: string;
  dfnSetVerNum?: string;
};
